export const getDeviceLogo = (vendor, isMobile) => {
    switch (vendor === null || vendor === void 0 ? void 0 : vendor.toLowerCase()) {
        case 'apple': {
            return 'apple';
        }
        case 'samsung': {
            return 'samsung';
        }
        case 'lenovo': {
            return 'lenovo';
        }
        case 'lg': {
            return 'lg';
        }
        case 'motorola': {
            return 'motorola';
        }
        case 'dell': {
            return 'dell';
        }
        case 'hp': {
            return 'hp';
        }
        default: {
            if (isMobile) {
                return 'phone';
            }
            return 'laptop';
        }
    }
};
